import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

export default function CustomerForm() {
  const navigate = useNavigate();
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>Add Customer</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Create a new customer record.
      </Typography>
      <Button component={Link} to="/app/customers" onClick={() => navigate('/app/customers')}>
        Back to Customers
      </Button>
    </Box>
  );
}
